import { generateBooleanSchema, generateRootObjectSchema, generateColorSchema, generateArraySchema} from "components/cards/common/schema";
import { BaseParticleSpec, GetParticlePropsType, GetParticleSchemaType, generateParticleContainerSchema } from "components/cards/particles/BaseParticleSpec";
import { TextParticleSpec } from "../Text/spec";

export const FormDropDownParticleSpec = new BaseParticleSpec("Form Drop Down Input", generateRootObjectSchema({
    container: generateParticleContainerSchema(),
    backgroundColor: generateColorSchema("Background Color", "The color of the background within the dropdown.", {
      defaultValue: "white"
    }),
    errorColor: generateColorSchema("Error Color", "The color of the error highlighting.", {
      defaultValue: "#ff4800"
    }),
    options: generateArraySchema("Dropdown Options", "Dropdown Option",
        TextParticleSpec.generateSchema("Dropdown Option", "Dropdown Option", {
            defaultValues: {
              color: "#949494",
            }
        })
    ),
    placeholderText: TextParticleSpec.generateSchema("Placeholder Text", "Any specified text becomes the placeholder for the dropdown.", {
      defaultValues: { text: "Placeholder", color: "#949494" }
    }),
    required: generateBooleanSchema("Required Input", "Indicates that this input is required.", {
      defaultValue: false
    }),
    isAnimated: generateBooleanSchema("Animated Labels", "Animate Label Text.", {
      defaultValue: true
    }),
    selectedColor: generateColorSchema("Selected Option Color", "The color of the selected option."),
    preselectOption: generateBooleanSchema('Preselect Option', 'Preselect the first dropdown option.', {
      defaultValue: false,
    }),
}));

export const specification = FormDropDownParticleSpec;

export type FormDropDownParticleSchema = GetParticleSchemaType<typeof FormDropDownParticleSpec>;

export type FormDropDownParticleProps = GetParticlePropsType<typeof FormDropDownParticleSpec>;
